import http from './http';

const URL_ROOT = '/nazioni';

export const getListNations = async () => {
  const response = await http.get(URL_ROOT);
  return response.data;
};
